import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { sectorStyle } from "@/lib/sectors";

export const feeLabel = (fee, t) => (fee > 0 ? `${fee} QAR` : t("free"));
export const slaLabel = (d, t) => (d > 0 ? `${d} ${t("days")}` : t("sameDay"));

export const ServiceRow = ({ s, index = 0 }) => {
  const { svcName, secName, t, me } = useApp();
  const st = sectorStyle(s.sector_id);
  const Icon = st.icon;
  const eligible = me?.user && s.eligible_personas?.includes(me.user.persona);
  return (
    <Link to={`/services/${s.service_id}`} data-testid={`service-row-${s.service_id}`}
      style={{ animationDelay: `${Math.min(index, 10) * 30}ms` }}
      className="q1-fade-up flex min-h-[56px] items-center gap-3 rounded-xl border border-border/60 bg-card px-3 py-2.5 shadow-sm transition-shadow hover:shadow-md">
      <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg" style={{ background: st.bg, color: st.color }}>
        <Icon size={19} aria-hidden="true" />
      </span>
      <span className="min-w-0 flex-1">
        <span className="block truncate text-sm font-semibold">{svcName(s)}</span>
        <span className="mt-0.5 flex flex-wrap items-center gap-x-2 text-[11px] text-muted-foreground">
          <span>{secName(s)}</span><span aria-hidden="true">·</span><span>{feeLabel(s.fee_qar, t)}</span>
          <span aria-hidden="true">·</span><span>{slaLabel(s.sla_days, t)}</span>
          {eligible && <span className="font-semibold text-[#0F5132] dark:text-emerald-400">✓ {t("eligible")}</span>}
        </span>
      </span>
      <ChevronRight size={16} className="q1-flip shrink-0 text-muted-foreground" aria-hidden="true" />
    </Link>
  );
};
